import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from '@livable/saas-react-components';
import { Fade, Input, InputAdornment, Typography } from '@mui/material';
import React, { useState } from 'react';
import useStyles from './styles';
const searchResults = {
  tenants: [{
    tenant: 'Demo Miguel Almanza',
    address: 'Unit 90, 775 Demo St., Santa Monica, 90402'
  }, {
    tenant: 'Demo Michael Ford',
    address: 'Unit 101A, 27500 Tampa Avenue, Santa Monica, 90402'
  }, {
    tenant: 'Demo James Michelin',
    address: 'Unit 102A, 27500 Tampa Avenue, Santa Monica, 90402'
  }],
  buildings: [{
    tenant: '1129 Michael Demo Ave',
    address: 'Redwood City, CA 94062, United States'
  }]
};
export default function HeaderSearch() {
  const classes = useStyles();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  const onFocus = () => {
    setIsFocused(true);
  };
  const onBlur = () => {
    setIsFocused(false);
  };
  const searchResultsRender = Object.keys(searchResults).map(key => /*#__PURE__*/React.createElement("div", {
    className: classes.resultCategory,
    key: key
  }, searchResults[key].map(result => /*#__PURE__*/React.createElement("div", {
    key: result.tenant,
    className: classes.result
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.tenantIcon
  }, key === 'tenants' && /*#__PURE__*/React.createElement(Icon, {
    type: "account-box"
  }), key === 'buildings' && /*#__PURE__*/React.createElement(Icon, {
    type: "property"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.flexGrow
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, result.tenant), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.address
  }, result.address)), /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-line-right"
  })))));
  return /*#__PURE__*/React.createElement("div", {
    className: "search-bar"
  }, /*#__PURE__*/React.createElement(Input, {
    placeholder: "Search",
    variant: "headerSearch",
    onFocus: onFocus,
    onBlur: onBlur,
    className: isFocused ? 'focused' : '',
    style: {
      display: 'none'
    } // NOTE: HeaderSearch Not for MVP
    ,
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    }))
  }), /*#__PURE__*/React.createElement(Fade, {
    in: isFocused
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.results
  }, searchResultsRender)));
}